const TONES = {
  LIVE: "text-pulse-soft",
  SYNCING: "text-brass-bright",
  DELAYED: "text-brass-bright",
  SIMULATION: "text-brass-bright",
  "COMING SOON": "text-brass-bright",
  OFFLINE: "text-red-400",
  UNAVAILABLE: "text-red-400",
  "NOT DEPLOYED": "text-fog-600",
};

const DOTS = {
  LIVE: "bg-pulse",
  SYNCING: "bg-brass",
  DELAYED: "bg-brass",
  SIMULATION: "bg-brass",
  "COMING SOON": "bg-brass",
  OFFLINE: "bg-red-400",
  UNAVAILABLE: "bg-red-400",
  "NOT DEPLOYED": "bg-fog-600",
};

export const DataStatus = ({ status = "NOT DEPLOYED", label, sub, className = "", pulse = true }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid={`data-status-${status.toLowerCase().replace(/\s/g, "-")}`}>
    <span className="relative inline-flex h-1.5 w-1.5 shrink-0">
      {pulse && status !== "NOT DEPLOYED" && (
        <span className={`absolute inline-flex h-full w-full rounded-full ${DOTS[status] || DOTS["NOT DEPLOYED"]} opacity-60 animate-ping`} />
      )}
      <span className={`relative inline-flex h-1.5 w-1.5 rounded-full ${DOTS[status] || DOTS["NOT DEPLOYED"]}`} />
    </span>
    <div className="flex flex-wrap items-baseline gap-x-2">
      <span className={`font-mono text-[10px] font-bold uppercase tracking-[0.2em] ${TONES[status] || TONES["NOT DEPLOYED"]}`}>
        {status}
      </span>
      {label && <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-fog-400">{label}</span>}
      {sub && <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-fog-600">{sub}</span>}
    </div>
  </div>
);
